import {createContext} from 'react';

const PersonalDetailsContext = createContext({});

PersonalDetailsContext.displayName = 'PersonalDetailsContext';

export default PersonalDetailsContext;
